// Imports
import {
	SetAdminViewAction,
	SetGlobalSignInAction,
	SetGlobalSignInLoadedAction,
	SetMemberLoadedAction,
	SetPhoneAction,
	SET_ADMIN_VIEW,
	SET_GLOBAL_SIGN_IN,
	SET_GLOBAL_SIGN_IN_LOADED,
	SET_MEMBER_LOADED,
	SET_PHONE,
	StoreHomepageVisibilityAction,
	StoreMemberAction,
	StorePagesAction,
	StoreWebsiteAction,
	STORE_HOMEPAGE_VISIBILITY,
	STORE_MEMBER,
	STORE_PAGES,
	STORE_WEBSITE,
} from './types';
import { GetWebsiteResponse } from '../../shareables/types/api/main/website/get';
import { GetPagesResponse } from '../../shareables/types/api/main/website/pages/get';
import { GetVisibilityResponse } from '../../shareables/types/api/main/website/homepage/visibility/get';
import { GetMemberResponse } from '../../shareables/types/api/main/website/member/get';


// Exports
const selfActions = {
	// Store website
	storeWebsite(website: GetWebsiteResponse): StoreWebsiteAction {
		return {
			type: STORE_WEBSITE,
			website: website,
		};
	},
	
	
	// Store pages
	storePages(pages: GetPagesResponse): StorePagesAction {
		return {
			type: STORE_PAGES,
			pages: pages,
		};
	},
	
	
	// Store homepage visibility
	storeHomepageVisibility(homepageVisibility: GetVisibilityResponse): StoreHomepageVisibilityAction {
		return {
			type: STORE_HOMEPAGE_VISIBILITY,
			homepageVisibility: homepageVisibility,
		};
	},
	
	
	// Store member
	storeMember(member: GetMemberResponse): StoreMemberAction {
		return {
			type: STORE_MEMBER,
			member: member,
		};
	},
	
	
	// Set member loaded
	setMemberLoaded(): SetMemberLoadedAction {
		return {
			type: SET_MEMBER_LOADED,
		};
	},
	
	
	// Set the admin view
	setAdminView(adminView: boolean): SetAdminViewAction {
		return {
			type: SET_ADMIN_VIEW,
			adminView: adminView,
		};
	},
	
	
	// Set global sign in state
	setGlobalSignIn(globalSignIn: boolean): SetGlobalSignInAction {
		return {
			type: SET_GLOBAL_SIGN_IN,
			globalSignIn: globalSignIn,
		};
	},
	
	
	// Set global sign in loaded
	setGlobalSignInLoaded(): SetGlobalSignInLoadedAction {
		return {
			type: SET_GLOBAL_SIGN_IN_LOADED,
		};
	},
	
	
	// Set phone number
	setPhone(phone: string | null): SetPhoneAction {
		return {
			type: SET_PHONE,
			phone: phone,
		};
	},
};

export default selfActions;
